export default "__VITE_ASSET__DNyKvZZJ__"